<template>
  <div class="flex flex-col h-full w-full lg:flex-row lg:overflow-hidden  ">
    <!-- Background para imagen -->
    <background class="w-full h-1/5 lg:h-full lg:w-6/12" />
    <!-- Control para el formulario -->
    <control class="flex w-full lg:w-6/12" />
  </div>
</template>

<script>
import Control from '@/components/Login/Control'
import Background from '@/components/Login/Background'

export default {
  name:'Login',
  components: {
      Control,
      Background,
  }
}
</script>